'use client';
import useGlobalContext from '@/hooks/useGlobalContext';
import React, {ReactNode, useEffect} from 'react';

interface Props {
  paths: {
    en: string;
    it: string;
    de: string;
    fr: string;
  }
}

const LanguageDropdownRoutes = ({paths}: Props) => {
  const {setDynamicUrl, setIsDynamicUrl} = useGlobalContext(); 

  useEffect(() => {
    setIsDynamicUrl(true)
    setDynamicUrl(paths);
    
    return () => {
      setIsDynamicUrl(false);
      setDynamicUrl({
        it: '',
        en: '',
        de: '',
        fr: '',
      });
    }
    // eslint-disable-next-line
  }, []);

  return <></>;
};

export default LanguageDropdownRoutes;
